import { h } from 'preact';
import { useState } from 'preact/hooks';
import { useContext } from './context';
import register from '@wcd/preact-custom-element';
import { BundlePrice } from '../../../types/web-components';

const renderBundlePrice = ({ formattedPrice, formattedDiscountPrice }) => {
  if (formattedPrice !== formattedDiscountPrice) {
    return (
      <div className="rdp-bundle__price">
        <div className="rdp-bundle__price-discounted">{formattedDiscountPrice}</div>
        <div className="rdp-bundle__price-original">was {formattedPrice}</div>
      </div>
    );
  }

  return <div className="rdp-bundle__price">{formattedPrice}</div>;
};

export const component: BundlePrice = ({ bundleid, symbol, amount }) => {
  const [formattedPrice, setFormattedPrice] = useState(`${symbol}${Number(amount).toFixed(2)}`);
  const [formattedDiscountPrice, setFormattedDiscountPrice] = useState('');

  useContext(({ resource }) => {
    const { bundles } = resource;
    const currentBundle = bundles?.find(({ id }) => Number(id) === Number(bundleid));
    const { formattedPrice: currencyConvertedPrice = '', formattedDiscountPrice = '' }: any = currentBundle;
    setFormattedPrice(currencyConvertedPrice);
    setFormattedDiscountPrice(formattedDiscountPrice);
  });

  return renderBundlePrice({ formattedPrice, formattedDiscountPrice });
};

register(component, 'tes-bundle-price', ['bundleid', 'symbol', 'amount'], { shadow: false });
